"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var moment = require("moment");
var datePicker_1 = require("../datePicker");
var hourPicker_1 = require("../hourPicker");
var DateTimePicker = /** @class */ (function (_super) {
    tslib_1.__extends(DateTimePicker, _super);
    function DateTimePicker(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChangeDate = function (date) {
            var _a = _this.props, onChange = _a.onChange, dateOnly = _a.dateOnly;
            var responseHour = !dateOnly ? (_this.getHour() || "0") : "0";
            onChange && onChange(_this.createResponse(date, responseHour));
        };
        _this.onChangeHour = function (e) {
            var _a = _this.props, onChange = _a.onChange, date = _a.date;
            var hour = e.target.value;
            var responseDate = date || moment();
            onChange && onChange(_this.createResponse(responseDate, hour));
        };
        return _this;
    }
    DateTimePicker.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, date = _a.date, dateOnly = _a.dateOnly;
        if (dateOnly !== prevProps.dateOnly && date) {
            this.onChangeDate(date);
        }
    };
    DateTimePicker.prototype.createResponse = function (date, hour) {
        return date.clone().hours(parseInt(hour, 10)).minutes(0).seconds(0).milliseconds(0);
    };
    DateTimePicker.prototype.getHour = function () {
        var date = this.props.date;
        return date ? date.hour().toString() : "";
    };
    DateTimePicker.prototype.getDate = function () {
        var date = this.props.date;
        return date ? date.clone() : null;
    };
    DateTimePicker.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, onChange = _b.onChange, label = _b.label, date = _b.date, dateFormat = _b.dateFormat, dateOnly = _b.dateOnly, dateProps = _b.dateProps, hourProps = _b.hourProps, disabled = _b.disabled, others = tslib_1.__rest(_b, ["theme", "className", "onChange", "label", "date", "dateFormat", "dateOnly", "dateProps", "hourProps", "disabled"]);
        var classes = classnames_1.default(theme.picker, className);
        return (React.createElement("div", { className: classes },
            label ? React.createElement("div", { className: theme.label }, label) : null,
            React.createElement(datePicker_1.default, tslib_1.__assign({ disabled: disabled, className: theme.date, date: this.getDate(), format: dateFormat, onChange: this.onChangeDate }, dateProps)),
            React.createElement(hourPicker_1.default, tslib_1.__assign({ disabled: disabled, className: classnames_1.default(theme.time, (_a = {}, _a[theme.hide] = dateOnly, _a)), hour: this.getHour(), onChange: this.onChangeHour }, hourProps))));
    };
    DateTimePicker.defaultProps = {
        date: moment(),
        dateOnly: false,
        dateProps: {},
        hourProps: {}
    };
    return DateTimePicker;
}(React.Component));
exports.default = DateTimePicker;
